import styled from 'styled-components';

export const SignContractWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 100%;
`;
